<template>
  <div
    @click="remainingClicked"
    @mouseenter="remainingHovered = true" 
    @mouseleave="remainingHovered = false"
    :id="`remaining-amount-${charge.id}`"
    :class="{hovered:remainingHovered, 'cursor-pointer':cursorClass}" 
    :style="getRemaining(charge)"
    :title="title"
    class="remaining-amount flex-center">
      <p :class="{sidebox:short}" class="m-0">${{(formatCurrency(charge.balance))}}</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        remainingHovered: false,
        short: '',
      }
    },
    props: {
      charge: Object,
      user: Object
    },
    mounted() {
      this.short = this.isShort()
    },
    computed: {
      title() {
        if (!this.user) return
        if (this.charge.balance >= this.user.payment_minimum) return 'Pay the rest off'
      },
      cursorClass() {
        if (!this.user) return
        if (this.charge.balance >= this.user.payment_minimum) return true
      }
    },
    methods: {
      getRemaining(charge) {
        const percentage = Math.round((charge.balance / charge.amount)*100)
        return `width: ${percentage}%;`
        
      },
      remainingClicked() {
        if (!this.user) return
        if (this.charge.balance >= this.user.payment_minimum)
          this.$emit('remainingClicked', this.formatCurrency(this.charge.balance))
      },
      isShort() {
        const remaingAmountElement = document.getElementById(`remaining-amount-${this.charge.id}`)
        return remaingAmountElement.offsetWidth >= 75 ? false : true
      },
    }
  }
</script>
